import { useAPI } from "hooks/api/useAPI";
import { postContact } from "hooks/api/utils";

export function useContact() {
  return useAPI(postContact, {});
}
